import styled from '@emotion/styled'

import LogoCarousel from '@segment/templates/LogoCarousel'
import { carouselLogos } from '@segment/templates/LogoCarousel/data'

const copy = {
  heading: `Over 13,000 mobile apps trust Segment to power data collection across 500 million devices.`,
}

const logos = [
  carouselLogos.BETTERMENT,
  carouselLogos.DOORDASH,
  carouselLogos.FOX,
  carouselLogos.DRAFT_KINGS,
  carouselLogos.HOUSEPARTY,
  carouselLogos.HOTEL_TONIGHT,
  carouselLogos.APARTMENT_LIST,
  carouselLogos.SPOT_HERO,
  carouselLogos.DELIVEROO,
  carouselLogos.CLASS_PASS,
  carouselLogos.CHIME,
]

const LogoCarouselComponent = () => {
  return (
    <Wrapper>
      <LogoCarousel heading={copy.heading} logos={logos} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: 60px;
`

export default LogoCarouselComponent
